import api from "../utils/api";

const BASE_URL = "/accounts/checks/register";

export const search = ({
  page = 0,
  size = 25,
  order = "checkDate",
  direction = "DESC",
  search = "",
  financialAccountUuid = "",
} = {}) => async () => {
  try {
    const params = new URLSearchParams();
    if (String(search || "").trim().length) params.set("search", String(search).trim());
    if (String(financialAccountUuid || "").trim().length) params.set("financialAccountUuid", financialAccountUuid);

    const query = params.toString();
    const url = `${BASE_URL}/p/${Number(page)}/s/${Number(size)}/o/${order}/${direction}${query ? `?${query}` : ""}`;
    const res = await api.get(url);
    return res.data;
  } catch (err) {
    return { success: false, items: [], count: 0, error: err?.response?.data?.error || err };
  }
};

export const next = ({ financialAccountUuid } = {}) => async () => {
  try {
    if (!financialAccountUuid) return { success: false, nextCheckNumber: "" };
    const res = await api.get(`${BASE_URL}/next/${financialAccountUuid}`);
    return res.data;
  } catch (err) {
    return { success: false, nextCheckNumber: "", error: err?.response?.data?.error || err };
  }
};

export const collisions = ({ financialAccountUuid, checkNumber, excludeJournalEntryUuid } = {}) => async () => {
  try {
    if (!financialAccountUuid || !checkNumber) return { success: true, warning: false, items: [], count: 0 };
    const query = excludeJournalEntryUuid ? `?excludeJournalEntryUuid=${encodeURIComponent(excludeJournalEntryUuid)}` : "";
    const res = await api.get(`${BASE_URL}/collisions/${financialAccountUuid}/${encodeURIComponent(checkNumber)}${query}`);
    return res.data;
  } catch (err) {
    return { success: false, warning: false, items: [], count: 0, error: err?.response?.data?.error || err };
  }
};

export const markPrinted = ({
  journalEntryUuid,
  financialAccountUuid,
  checkNumber,
  checkDate,
} = {}) => async () => {
  try {
    if (!journalEntryUuid) return { success: false };
    const res = await api.post(`${BASE_URL}/printed/${journalEntryUuid}`, {
      financialAccountUuid,
      checkNumber,
      checkDate,
    });
    return res.data;
  } catch (err) {
    return { success: false, error: err?.response?.data?.error || err };
  }
};
